(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "../../user/util/userAssertions", "../../braindate/util/braindateAssertions", "@braindate/util/lib/assert", "./expressionOfGratitudeAssertions"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("../../user/util/userAssertions"), require("../../braindate/util/braindateAssertions"), require("@braindate/util/lib/assert"), require("./expressionOfGratitudeAssertions"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.userAssertions, global.braindateAssertions, global.assert, global.expressionOfGratitudeAssertions);
    global.expressionOfGratitudeGetters = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _userAssertions, _braindateAssertions, _assert, _expressionOfGratitudeAssertions) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getExpressionOfGratitudeUnwrapitUrl = _exports.getExpressionOfGratitudeSender = _exports.getExpressionOfGratitudeSendGift = _exports.getExpressionOfGratitudeRecipient = _exports.getExpressionOfGratitudePath = _exports.getExpressionOfGratitudeMessage = _exports.getExpressionOfGratitudeMarkAsReadUrl = _exports.getExpressionOfGratitudeId = _exports.getExpressionOfGratitudeDateSent = _exports.getExpressionOfGratitudeDateRead = _exports.getExpressionOfGratitudeBraindate = void 0;

  /**
   * Gets the expression of gratitude object id
   * @param {ExpressionOfGratitude} expressionOfGratitude - Expression of gratitude
   * @returns {number} id
   */
  var getExpressionOfGratitudeId = function getExpressionOfGratitudeId(expressionOfGratitude) {
    (0, _expressionOfGratitudeAssertions.assertExpressionOfGratitude)(expressionOfGratitude);
    var id = expressionOfGratitude.id;
    (0, _assert.assertNumber)(id);
    return id;
  };

  /**
   * Gets the expression of gratitude sender
   * @param {ExpressionOfGratitude} expressionOfGratitude - Expression of gratitude
   * @returns {User} sender
   */
  _exports.getExpressionOfGratitudeId = getExpressionOfGratitudeId;
  var getExpressionOfGratitudeSender = function getExpressionOfGratitudeSender(expressionOfGratitude) {
    (0, _expressionOfGratitudeAssertions.assertExpressionOfGratitude)(expressionOfGratitude);
    var sender = expressionOfGratitude.sender;
    (0, _userAssertions.assertUser)(sender);
    return sender;
  };

  /**
   * Gets the expression of gratitude recipient
   * @param {ExpressionOfGratitude} expressionOfGratitude - Expression of gratitude
   * @returns {User} recipient
   */
  _exports.getExpressionOfGratitudeSender = getExpressionOfGratitudeSender;
  var getExpressionOfGratitudeRecipient = function getExpressionOfGratitudeRecipient(expressionOfGratitude) {
    (0, _expressionOfGratitudeAssertions.assertExpressionOfGratitude)(expressionOfGratitude);
    var recipient = expressionOfGratitude.recipient;
    (0, _userAssertions.assertUser)(recipient);
    return recipient;
  };

  /**
   * Gets the expression of gratitude braindate
   * @param {ExpressionOfGratitude} expressionOfGratitude - Expression of gratitude
   * @returns {Braindate} braindate
   */
  _exports.getExpressionOfGratitudeRecipient = getExpressionOfGratitudeRecipient;
  var getExpressionOfGratitudeBraindate = function getExpressionOfGratitudeBraindate(expressionOfGratitude) {
    (0, _expressionOfGratitudeAssertions.assertExpressionOfGratitude)(expressionOfGratitude);
    var braindate = expressionOfGratitude.braindate;
    (0, _braindateAssertions.assertBraindate)(braindate);
    return braindate;
  };

  /**
   * Gets the expression of gratitude message
   * @param {ExpressionOfGratitude} expressionOfGratitude - Expression of gratitude
   * @returns {string} message
   */
  _exports.getExpressionOfGratitudeBraindate = getExpressionOfGratitudeBraindate;
  var getExpressionOfGratitudeMessage = function getExpressionOfGratitudeMessage(expressionOfGratitude) {
    (0, _expressionOfGratitudeAssertions.assertExpressionOfGratitude)(expressionOfGratitude);
    var message = expressionOfGratitude.message;
    (0, _assert.assertString)(message);
    return message;
  };

  /**
   * Gets the expression of gratitude date sent
   * @param {ExpressionOfGratitude} expressionOfGratitude - Expression of gratitude
   * @returns {string} date
   */
  _exports.getExpressionOfGratitudeMessage = getExpressionOfGratitudeMessage;
  var getExpressionOfGratitudeDateSent = function getExpressionOfGratitudeDateSent(expressionOfGratitude) {
    (0, _expressionOfGratitudeAssertions.assertExpressionOfGratitude)(expressionOfGratitude);
    var dateSent = expressionOfGratitude.date_sent;
    (0, _assert.assertString)(dateSent);
    return dateSent;
  };

  /**
   * Gets the expression of gratitude date sent
   * @param {ExpressionOfGratitude} expressionOfGratitude - Expression of gratitude
   * @returns {string | undefined} date
   */
  _exports.getExpressionOfGratitudeDateSent = getExpressionOfGratitudeDateSent;
  var getExpressionOfGratitudeDateRead = function getExpressionOfGratitudeDateRead(expressionOfGratitude) {
    (0, _expressionOfGratitudeAssertions.assertExpressionOfGratitude)(expressionOfGratitude);
    var dateRead = expressionOfGratitude.date_read;
    if (!dateRead) return null;
    (0, _assert.assertString)(dateRead);
    return dateRead;
  };

  /**
   * Gets the expression of gratitude unwrapit url
   * @param {ExpressionOfGratitude} expressionOfGratitude - Expression of gratitude
   * @returns {string | undefined} url
   */
  _exports.getExpressionOfGratitudeDateRead = getExpressionOfGratitudeDateRead;
  var getExpressionOfGratitudeUnwrapitUrl = function getExpressionOfGratitudeUnwrapitUrl(expressionOfGratitude) {
    (0, _expressionOfGratitudeAssertions.assertExpressionOfGratitude)(expressionOfGratitude);
    var unwrapitUrl = expressionOfGratitude.unwrapit_url;
    if (!unwrapitUrl) return undefined;
    (0, _assert.assertString)(unwrapitUrl);
    return unwrapitUrl;
  };

  /**
   * Gets the expression of gratitude mark as read url
   * @param {ExpressionOfGratitude} expressionOfGratitude - Expression of gratitude
   * @returns {string | undefined} url
   */
  _exports.getExpressionOfGratitudeUnwrapitUrl = getExpressionOfGratitudeUnwrapitUrl;
  var getExpressionOfGratitudeMarkAsReadUrl = function getExpressionOfGratitudeMarkAsReadUrl(expressionOfGratitude) {
    (0, _expressionOfGratitudeAssertions.assertExpressionOfGratitude)(expressionOfGratitude);
    var url = expressionOfGratitude.mark_as_read;
    if (!url) return undefined;
    (0, _assert.assertString)(url);
    return url;
  };

  /**
   * Gets the expression of gratitude send gift
   * @param {ExpressionOfGratitude} expressionOfGratitude - Expression of gratitude
   * @returns {boolean} boolean
   */
  _exports.getExpressionOfGratitudeMarkAsReadUrl = getExpressionOfGratitudeMarkAsReadUrl;
  var getExpressionOfGratitudeSendGift = function getExpressionOfGratitudeSendGift(expressionOfGratitude) {
    (0, _expressionOfGratitudeAssertions.assertExpressionOfGratitude)(expressionOfGratitude);
    var sendGift = expressionOfGratitude.send_gift;
    (0, _assert.assertBoolean)(sendGift);
    return sendGift;
  };

  /**
   * Gets the expression of gratitude path
   * @param {ExpressionOfGratitude} expressionOfGratitude - Expression of gratitude
   * @returns {string} url
   */
  _exports.getExpressionOfGratitudeSendGift = getExpressionOfGratitudeSendGift;
  var getExpressionOfGratitudePath = function getExpressionOfGratitudePath(expressionOfGratitude) {
    (0, _expressionOfGratitudeAssertions.assertExpressionOfGratitude)(expressionOfGratitude);
    var path = expressionOfGratitude.path;
    (0, _assert.assertString)(path);
    return path;
  };
  _exports.getExpressionOfGratitudePath = getExpressionOfGratitudePath;
});